module.exports = __webpack_public_path__ + "img/atc.a94e0cb0.svg";